/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { ReportType } from '../types/ReportType';
import { PpcFormat } from '../types/PpcFormat';
import { ReportFormControl } from '../types/ReportFormControl';
import { TextPredicateOp } from '../../../app-data/models/TPFilterPredicates';
import { ExternalLinkage } from '../types/ExternalLinkage';
import { ExportFormatType } from '../types/ExportFormatType';
import { Validators } from '@angular/forms';

export const DEFAULT_WBS_GROUPING_LEVEL = 4;
export const DEFAULT_NUMBER_OF_WEEKS = '1';

// Define the default values object
export const DEFAULT_REPORT_FORM_VALUES: { [key in ReportFormControl]: any } = {
	[ReportFormControl.ArchivedPlansDropDown]: [],
	[ReportFormControl.AsOfDate]: '',
	[ReportFormControl.BreakUpBy]: null,
	[ReportFormControl.CSVExportType]: 'project',
	[ReportFormControl.CSVPlan]: null,
	[ReportFormControl.CustomField1]: null,
	[ReportFormControl.CustomField2]: null,
	[ReportFormControl.CustomField3]: null,
	[ReportFormControl.CustomFields]: [],
	[ReportFormControl.EndDate]: '',
	[ReportFormControl.ExportFormatTemplate]: null,
	[ReportFormControl.ExportFormatType]: ExportFormatType.Touchplan,
	[ReportFormControl.ExternalLinkage]: ExternalLinkage.AllTickets,
	[ReportFormControl.FilterByCustomFieldsToggle]: false,
	[ReportFormControl.GroupBy]: null,
	[ReportFormControl.IncludeCompleted]: false,
	[ReportFormControl.IncludePullTickets]: true,
	[ReportFormControl.IncludeWBSCodeFilterToggle]: false,
	[ReportFormControl.Locations]: [],
	[ReportFormControl.NumberOfWeeks]: DEFAULT_NUMBER_OF_WEEKS,
	[ReportFormControl.OnlyLate]: false,
	[ReportFormControl.Plans]: [],
	[ReportFormControl.PpcFormat]: PpcFormat.PpcByWeek,
	[ReportFormControl.ReportType]: ReportType.WeeklyWorkPlan,
	[ReportFormControl.Roles]: [],
	[ReportFormControl.SortBy]: null,
	[ReportFormControl.SortGroupsBy]: null,
	[ReportFormControl.Swimlanes]: [],
	[ReportFormControl.TicketTypes]: [],
	[ReportFormControl.TimeScale]: null,
	[ReportFormControl.WbsCodeFilterConfig]: { value: null, operator: TextPredicateOp.AnyValue },
	[ReportFormControl.WbsGroupingLevel]: DEFAULT_WBS_GROUPING_LEVEL,
};

export const REPORT_FORM_CONTROLS = {
	archivedPlansDropDown: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.ArchivedPlansDropDown]],
	asOfDate: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.AsOfDate], [Validators.required]],
	breakUpBy: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.BreakUpBy]],
	csvExportType: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CSVExportType]],
	csvPlan: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CSVPlan]],
	customFields: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CustomFields]],
	customField1: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CustomField1]],
	customField2: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CustomField2]],
	customField3: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.CustomField3]],
	endDate: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.EndDate], [Validators.required]],
	exportFormatTemplate: [
		DEFAULT_REPORT_FORM_VALUES[ReportFormControl.ExportFormatTemplate],
		[Validators.required],
	],
	exportFormatType: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.ExportFormatType]],
	externalLinkage: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.ExternalLinkage]],
	filterByCustomFieldsToggle: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.FilterByCustomFieldsToggle]],
	groupBy: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.GroupBy]],
	includeCompleted: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.IncludeCompleted]],
	includePullTickets: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.IncludePullTickets]],
	includeWBSCodeFilterToggle: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.IncludeWBSCodeFilterToggle]],
	locations: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.Locations]],
	numberOfWeeks: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.NumberOfWeeks]],
	onlyLate: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.OnlyLate]],
	plans: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.Plans]],
	ppcFormat: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.PpcFormat]],
	reportType: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.ReportType]],
	roles: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.Roles]],
	sortBy: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.SortBy]],
	sortGroupsBy: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.SortGroupsBy]],
	swimlanes: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.Swimlanes]],
	ticketTypes: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.TicketTypes]],
	timeScale: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.TimeScale]],
	wbsCodeFilterConfig: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.WbsCodeFilterConfig]],
	wbsGroupingLevel: [DEFAULT_REPORT_FORM_VALUES[ReportFormControl.WbsGroupingLevel]],
};
